<span *ngIf="errors?.['required']">{{ errors?.['required']?.message ?? 'Обязательно к заполнению' }}</span>
<span *ngIf="errors?.['minlength']">Обязательно к заполнению</span>
<span *ngIf="errors?.['maxlength']">Превышено количество символов</span>
